import { http } from './http';
import { unwrapSuccess } from './helpers';

export async function listAccounts(page, size) {
    const res = await http.get('/accounts', {
        params: { page, size },
    });
    return unwrapSuccess(res);
}

export async function listCurrencies() {
    const res = await http.get('/accounts/currencies');
    return unwrapSuccess(res);
}

export async function createAccount(payload) {
    const res = await http.post('/accounts', payload); // RESTful: множественное Название
    return unwrapSuccess(res);
}

export async function updateAccount(id, payload) {
    const res = await http.put(`/accounts/${id}`, payload);
    return unwrapSuccess(res);
}

export async function deleteAccount(id) {
    return http.delete(`/accounts/${id}`);
}
export async function sortAccountList(payload) {
    return http.post(`/accounts/sort`, payload);
}

export async function clearAccount() {
    return http.delete('/accounts');
}
